import styled from 'styled-components';

import Paper from '@mui/material/Paper';

export const Container = styled(Paper)`
  background-color: ${({ theme }) => theme.palette.neutral.offWhite};
  margin-bottom: 96px;
  padding: 24px;
`;
